import { AntDesign } from "@expo/vector-icons";
import { LayoutNodeFilter } from "@towersystems/roam-common/lib/generated-types";
import { Chip, Spacings, Colors } from "react-native-ui-lib";
import { HStack } from "@towersystems/roam-common-native";
import { useFilterMetadata } from "../../../../../../utilities/filter-metadata";
import { filterTypeToFilterValueMetaType } from "../../../../../../utilities/layout";
import { toTitleCase } from "../../../../../../utilities/to-title-case";

type FilterChipsProps = {
  filter: LayoutNodeFilter;
};

export function FilterChipsList({ filter }: FilterChipsProps) {
  const filterMetadataContext = useFilterMetadata();

  const filterChipsMarkup = filter.values.map((value) => {
    const label = filterMetadataContext.getFromCache(
      filterTypeToFilterValueMetaType(filter.type),
      value
    );

    return (
      <Chip
        key={value}
        label={toTitleCase(label || "")}
        containerStyle={{ border: "none" }}
        leftElement={
          <AntDesign
            name="filter"
            size={16}
            style={{ marginLeft: Spacings.s2 }}
            color={Colors.white}
          />
        }
        labelStyle={{ color: Colors.white }}
        backgroundColor={Colors.primary}
      />
    );
  });

  return <HStack spacing={Spacings.s2}>{filterChipsMarkup}</HStack>;
}
